import React from 'react'
import PropTypes from 'prop-types'

import getLabels from '../../utils/getLabels'
import Button from '../Button'
import PopUp from '../PopUp'

const ErrorMessage = ({ classes, message, showReloadButton = true }) => {
  return (
    <PopUp>
      <h1 className={classes.title}>{getLabels('error_heading')}</h1>
      <p>{message}</p>
      <p>{getLabels('error_disclaimer')}</p>
      {showReloadButton &&
        <Button onClick={() => window.location.reload()}className={classes.button}>
          {getLabels('reload')}
        </Button>
      }
    </PopUp>
  )
}

ErrorMessage.propTypes = {
  message: PropTypes.string,
  classes: PropTypes.shape({
    title: PropTypes.string,
    button: PropTypes.string,
  }),
  showReloadButton: PropTypes.bool
}

export default ErrorMessage
